module.exports = __webpack_public_path__ + "img/logo-big.4ba5013b.png";